<template>
  <table class="svgchart_legend">
    <tr v-if="oopPlayer">
      <td>
        <div class="svgchart_legend_player">
          <slot name="icon_oop">
            <div
              class="svgchart_legend_player_circle"
              style="background: var(--clr-player_oop)"
            ></div>
          </slot>
          {{ oopPlayer.position }}
          <i
            v-if="oopPlayer.is_hero"
            class="mdi mdi-crown svgchart_legend_player_crown"
          ></i>
        </div>
      </td>
      <td class="svgchart_legend_player_slot">
        <slot name="oop"></slot>
      </td>
    </tr>
    <tr v-if="ipPlayer">
      <td>
        <div class="svgchart_legend_player">
          <slot name="icon_ip">
            <div
              class="svgchart_legend_player_circle"
              style="background: var(--clr-player_ip)"
            ></div>
          </slot>
          {{ ipPlayer.position }}
          <i
            v-if="ipPlayer.is_hero"
            class="mdi mdi-crown svgchart_legend_player_crown"
          ></i>
        </div>
      </td>
      <td class="svgchart_legend_player_slot">
        <slot name="ip"></slot>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ChartLegendPlayers',
  props: {
    oopPlayer: Object,
    ipPlayer: Object,
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.svgchart {
  &_legend {
    position: absolute;
    --legend-size: 0.875rem;
    --legend-circle-size: 10px;
    --legend-item-padding: 0.075rem 0;
    --legend-inset: 1.25rem auto auto 1.875rem;
    z-index: 3;
    inset: var(--legend-inset);
    &_player {
      line-height: 1;
      font-size: var(--legend-size);
      padding: var(--legend-item-padding);
      color: var(--clr-grey-2);
      display: flex;
      align-items: center;
      &_circle {
        margin-right: 4px;
        width: var(--legend-circle-size);
        height: var(--legend-circle-size);
        border-radius: 50%;
      }
      &_crown {
        margin-left: 2px;
      }
      &_slot {
        line-height: 1;
        font-size: var(--legend-size);
        color: var(--clr-grey-2);
      }
    }
  }
}
</style>
